 import { message } from 'antd'
import Email from '../../../../api/Email'
import { MRNApi } from '../../../../api/HSEQ/MRN'
import Templates from '../../../../api/Templates'
import AddMRN from '../../../../components/HSEQ/MRN/AddMRN/AddMRN'
import useActions from '../../../../elements/Hooks/useActions'
import useModalData, { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get } from 'lodash'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import useFetchList from '../../../../elements/Hooks/useFetchList'

AddMRNCont.propTypes = {}

const templateApi = new Templates()
const emailApi = new Email()

function AddMRNCont (props) {
  const key = get(props.match, 'params.key')

  const {
    visible,
    modalType,
    object: mrn,
    setObject: setMRN,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    MRNApi.create,
    MRNApi.update,
    MRNApi.remove,
    undefined,
    key,
    MRNApi.read,
    (key) => {
      props.history.replace({
        pathname: `/hseq/mrn/${key}/update`,
      })
    },
    () => {
      props.history.replace({
        pathname: `/hseq/mrn/list/`,
      })
    },
  )
  let { list: lines, fetching: fetchingLines, fetch: fetchLines } = useFetchList(() =>
    MRNApi.getLinesByMRN(key),
  )

  const {
    actions,
    fetchingActions,
    fetchActions,
    submittingOperation,
    submitOperation,
    handleActions,
  } = useActions('mrn', mrn, setMRN, MRNApi.operation)

  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const isNew = type === MODAL_TYPE_NEW
  useTitle(mrn.code === undefined ? `Create New MRN` : `${mrn.code} Material Release Note`)

  const isUpdatable = isNew ? true : actions.find((a) => a.key === 'update')
  const isApproved = mrn.status === 'Approved'

  const [_3, submitTemplate] = useSubmit(templateApi.read, true)
  const [_1, submitMRNTemplate] = useSubmit(emailApi.mrnTemplate, true)
  const [_2, submitMRNFiles] = useSubmit(MRNApi.files, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(
    async () => {
      let hide = message.loading('Fetching Email Template ...', 0)

      const emailLines = lines.map((l) => ({
        _id: l._id,
        _key: l._key,
        no: l.purchasesLines.no,
        name: l.purchasesLines.name,
        totalUnits: l.totalUnits,
        unit: l.unit,
        uom: l.purchasesLines.uom.code,
      }))

      const company = get(mrn, 'company._id', '').replace('members/', '')
      const mrnTemplate = await submitTemplate(company, 'mrn')
      const emailDetails = get(mrnTemplate, 'email') || {}
      const data = await submitMRNTemplate({
        receiver: get(mrn, 'vendorRep.fn'),
        companyRep: get(mrn, 'companyRep.fn'),
        company: get(mrn, 'company.fn'),
        code: get(mrn, 'code'),
        poNo: get(mrn, 'purchases.code'),
        address: get(mrn, 'company.address.label'),
        phone: get(mrn, 'company.phone.label'),
        url: get(mrn, 'url'),
        lines: emailLines,
        ...emailDetails,
      })

      const filesList = await submitMRNFiles([mrn._id])
      setEmailFiles(filesList)
      const filesMapped = filesList.map((f) => f.uuid)
      setEmailTemplate(data.html)
      setEmailDetails({
        to: get(mrn, 'vendorRep.email.label'),
        cc: get(mrn, 'companyRep.email.label'),
        bcc: get(emailDetails, 'bcc'),
        from: get(emailDetails, 'from'),
        subject: `[${get(mrn, 'code')}] ${get(emailDetails, 'subject')}`,
        attachments: filesMapped,
      })
      setEmailLines([mrn])
      hide()
    },
  )

  return (
    <AddMRN
      {...{
        type,
        visible,
        modalType,
        mrn,
        submitting,
        submit,
        removing,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
        isNew,
        actions,
        isApproved,
        fetchingActions,
        fetchActions,
        submittingOperation,
        submitOperation,
        handleActions,
        fetching,
        fetch,
        isUpdatable,
        onShowEmail,
        visibleEmail,
        onCancelEmail,
        emailTemplate,
        emailDetails,
        emailFiles,
        emailLines,
      }}
    />
  )
}

export default withRouter(AddMRNCont)
